import request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 获取验证码
   */
  static getVerifyCode(params) {
    return request({
      url: `user/verifyCode/getVerifyCodeV3`,
      host: config.HOST_MALL,
      ignoreErr: true,
      params
    });
  }

  static getCardCodeName(params) {
    return request({
      url: `personal/queryMemberNameByCardCode?cardCode=${params}`,
      host: config.HOST_MALL,
      ignoreErr: true
    });
  }

  /**
   * 注册 - 会员新客注册时
   */
  static register(params) {
    return request({
      url: 'user/register/confirmOrRegister',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 获取卡信息
   */
  static getCardCodeInfo(params) {
    return request({
      url: `personal/queryRegisterCardCode`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 校验实体卡密是否正确
   */
  static applyPhysicalCard(params) {
    return request({
      url: 'user/register/checkEntityCard',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 查询是否可开实体卡或虚拟卡
   */
  static queryCanApplyType(params) {
    return request({
      url: 'user/register/checkOpenCardAttribute',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 获取协议(registration: 注册须知，agency: 经销商合同)
   */
  static getAgreement(type) {
    return request({
      url: `basic/contract/query/${type}`,
      host: config.HOST_MALL
    });
  }

  // 申请开卡
  static apply(params) {
    return request({
      url: `user/register/queryCardType`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params,
      ignoreErr: true
    });
  }

  /**
   * 获取老客升级卡类型列表
   */
  static getCardTypeList(url, params) {
    return request({
      url,
      host: url == 'user/upgrade/queryCardType' ? config.HOST_MALL : config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/AgentRegister/AgentRegisterServ.js